module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "about-the-author"
    }
  }, [_c('h1', [_vm._v("About the Author")]), _vm._v(" "), _c('p', [_vm._v("Gordon Wilson is emeritus professor in Environment and Development. He has previously co-authored "), _c('em', [_vm._v("Learning for Development")]), _vm._v(", "), _c('em', [_vm._v("The Lived Experience of Climate Change")]), _vm._v(" and "), _c('em', [_vm._v("Environment, Development and Sustainability")]), _vm._v(", as well as invited chapters for nine further books. He has published "), _c('em', [_vm._v("The Pyrenees: Trekking the Mountains of Hope and Freedom")]), _vm._v(".")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_vm._v("Steve Cracknell has written three other books on the Pyrenees. In the first two, the mountains and their inhabitants are seen through the eyes of a long-distance walker. His third work, "), _c('em', [_vm._v("The Implausible Rewilding of the Pyrenees")]), _vm._v(" is based on interviews with shepherds, farmers, environmentalists and hunters, some of whom also feature in "), _c('em', [_vm._v("Mountain People")]), _vm._v(". The author and environmentalist Dr Mark Avery chose it for his Nature Book of the Year, 2021.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0bbe9e50","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch001.vue
// module id = 63
// module chunks = 0